import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function AddNewPropertyIcon({
  className,
  fill,
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface) {
  return (
    <SimpleIcon
      className={className}
      fill={fill ?? 'none'}
      height={height ?? '18'}
      viewBoxDimensions="0 0 18 18"
      width={width ?? '18'}
    >
      <path
        d="M9.4668 6V3H6.4668"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.9668 6H4.9668C4.13837 6 3.4668 6.67157 3.4668 7.5V13.5C3.4668 14.3284 4.13837 15 4.9668 15H13.9668C14.7952 15 15.4668 14.3284 15.4668 13.5V7.5C15.4668 6.67157 14.7952 6 13.9668 6Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M1.9668 10.5H3.4668"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15.4668 10.5H16.9668"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.7168 9.75V11.25"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M7.2168 9.75V11.25"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SimpleIcon>
  );
}
